import {useEffect, useState, useRef} from 'react';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import {filterStringArray, FilterTextfield} from '../pin_management';
import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import {ColumnTypes} from '../hl7/hl7_messages_comp';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import {useTranslation} from 'react-i18next';
import API from '../../../app/api';
import {useDispatch} from 'react-redux';
import {setLoading} from "../../../store/reducers/patient";
import _ from 'lodash';
import {AgyleNamedIcon} from '../../../components/icons/agyle';
import MessageBox from '../../../util/messageBox';
import {useWebSocket} from '../../../context/WebSocketProvider';

const CHANNELS = [`db_audits_auditType.description_deleteTrustedDevice`, 'db_audits_auditType.description_setTrustedDevice', 'db_audits_auditType.description_unlockTrustedDevice', 'db_audits_auditType.description_lockTrustedDevice'];

const TrustedDevices = props => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {manageSubscription, message} = useWebSocket();

    const [filterValue, setFilterValue] = useState("");
    const [switchValue, setSwitchValue] = useState('all');
    const [devices, setDevices] = useState([]);
    const [filteredDevices, setFilteredDevices] = useState([]);

    const deviceRef = useRef(null)

    const [isUnlockDeviceDialogOpen, setIsUnlockDeviceDialogOpen] = useState(false);
    const [isRemoveDeviceDialogOpen, setIsRemoveDeviceDialogOpen] = useState(false);

    const openConfirmRemoveDevice = () => setIsRemoveDeviceDialogOpen(true);
    const openConfirmUnlockDevice = () => setIsUnlockDeviceDialogOpen(true);

    useEffect(() => {
        manageSubscription(CHANNELS);
    }, []);

    const resetDeviceRef = () => {
        const timeout = setTimeout(() => deviceRef.current = null, 500);

        return () => clearTimeout(timeout);
    }

    const closeConfirmRemoveDevice = () => {
        setIsRemoveDeviceDialogOpen(false);
        resetDeviceRef();
    }
    const closeConfirmUnlockDevice = () => {
        setIsUnlockDeviceDialogOpen(false);
        resetDeviceRef();
    }

    const getTrustedDevices = async () => {
        dispatch(setLoading(true));
        try {
            API.getAllTrustedDevices().then(res => {
                setDevices(res.data.__data);
                setFilteredDevices(res.data.__data);
            })
        } catch (err) {
            props.renderErrorSnackbar("Error fetching trusted devices. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const unlockDevice = async (device) => {
        dispatch(setLoading(true));

        let dataToPass = {
            "deviceId": device.deviceId,
            "deviceName": device.deviceName
        };

        try {
            const apiResponse = await API.addTrustedDevices(dataToPass)
            if (apiResponse.success) {
                props.renderSuccessSnackbar("Device unlocked successfully.");
                closeConfirmUnlockDevice();
                getTrustedDevices();
            }
        } catch (e) {
            props.renderErrorSnackbar("Error unlocking device. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const untrustDevice = async (device) => {
        dispatch(setLoading(true));

        try {
            API.removeTrustedDevice(device?.__id).then(res => {
                props.renderSuccessSnackbar("Device untrusted successfully");
                closeConfirmRemoveDevice();
                getTrustedDevices();
            })
        } catch (e) {
            props.renderErrorSnackbar("Error untrusting device. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const devicesColumns = [
        {
            name: 'action',
            order: 1,
            value: 'deviceId',
            type: ColumnTypes.TEXT,
            description: "Device ID",
            // minWidth: "25%",
            width: '30%',
            maxWidth: 40
        },
        {
            name: 'action',
            order: 1,
            value: 'deviceName',
            type: ColumnTypes.TEXT,
            description: 'Device Name',
            // minWidth: "25%",
            width: '30%',
            maxWidth: 40
        },
        {
            name: 'trusted',
            order: 1,
            value: 'trusted',
            type: ColumnTypes.TEXT,
            description: 'Device Status',
            minWidth: "25%",
            width: '20%',
            // maxWidth: 40
        },
        {
            name: 'action',
            order: 1,
            value: 'actions',
            type: ColumnTypes.ACTIONS,
            description: 'Actions',
            minWidth: "25%",
            width: '20%',
            // maxWidth: 40,
            actionList: [
                // {
                //     // callback: lockDevice,
                //     callback: openConfirmLockDevice,
                //     buttonLabel: "Lock Device",
                //     icon: 'padlock',
                //     iconColor: '#F7A202'
                // },
                {
                    callback: (device) => {
                        deviceRef.current = device;
                        openConfirmUnlockDevice();
                    },
                    buttonLabel: "Unlock Device",
                    icon: 'pinAdministration',
                    iconColor: '#F7A202'
                },
                {
                    // callback: untrustDevice,
                    callback: (device) => {
                        deviceRef.current = device;
                        openConfirmRemoveDevice();
                    },
                    buttonLabel: "Untrust",
                    icon: 'removeBin',
                    iconColor: '#E25B61'
                }
            ],
        },
    ]

    const handleChangeFilterText = (value) => {
        setFilterValue(value)
    }

    const handleFilterDevices = () => {
        switch (switchValue) {
            case 'all':
                setFilteredDevices(devices);
                break;
            case 'trusted':
                setFilteredDevices(devices.filter(device => device.trusted && device.failedLoginAttempts < 3));
                break;
            case 'untrusted':
                setFilteredDevices(devices.filter(device => !device.trusted));
                break;
            case 'locked':
                setFilteredDevices(devices.filter(device => device.failedLoginAttempts >= 3));
                break;
            default:
                setFilteredDevices(devices);
                break;
        }
    }

    const filterTextDevices = (val) => {filterStringArray(val, 'deviceName', devices, setFilteredDevices)}

    useEffect(() => {
        // if (_.isEmpty(filteredDevices)) {
            handleFilterDevices();
        // }
    }, [switchValue])


    useEffect(() => {
        getTrustedDevices();
    }, []);

    useEffect(() => {
        if (message) {
            getTrustedDevices();
        }
    }, [message]);

    const parseBooleanValue = (bool, locked) => locked ? "Locked" : bool ? "Trusted" : "Untrusted";

    const getDeviceStatusBackground = (value) => {
        if (value === "Locked") {
            return "#F7A202";
        } else if (value === "Untrusted") {
            return "#E25B61";
        } else if (value === "Trusted") {
            return "#4EAC6F";
        } else {
            return "#FFC107";
        }
    }
    const getDeviceStatusColor = (value) => {
        if (value === "Locked") {
            return "#000";
        } else if (value === "Untrusted") {
            return "#FFF";
        } else if (value === "Trusted") {
            return "#FFF";
        } else {
            return "#000";
        }
    }

    const renderDeviceStatus = (device) => {
        const deviceStatus = parseBooleanValue(device?.trusted, device?.failedLoginAttempts >= 3);
        return (
            <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                <Typography variant="body2" sx={{
                    borderRadius: 2,
                    py: 0.75,
                    px: 2,
                    minWidth: '95px',
                    textAlign: 'center',
                    color: getDeviceStatusColor(deviceStatus),
                    background: getDeviceStatusBackground(deviceStatus)
                }}>
                    {deviceStatus}
                </Typography>
            </Box>)
    }

    const renderButtons = (btns, row) => {
        let buttons = [];
        if (!row.trusted) return buttons;
        btns.actionList.forEach((action)=>{
            if (action.buttonLabel === "Lock Device" && row.locked) return;
            if (action.buttonLabel === "Unlock Device" && row.failedLoginAttempts < 2) return;

            buttons.push(
                <Button
                    key={action.buttonLabel}
                    style={{
                        color: action.iconColor,
                        boxShadow: '0 0 5px rgba(0, 0, 0, 0.25)',
                        marginRight: action.icon === 'padlock' ? "10px" : ""
                    }}
                    onClick={() => action.callback(row)}
                >
                    <AgyleNamedIcon
                        style={{display: 'flex'}}
                        name={action.icon}
                        customTooltip={action.buttonLabel}
                        withTooltip
                    />
                </Button>
            )
        })

        return (
            <>
                {buttons}
            </>
        )
    }

    return (
        <Grid container spacing={2}>
            <FilterTextfield onChange={handleChangeFilterText} value={filterValue} findValues={filterTextDevices}/>

            <Grid item xs={12} style={{margin:0, padding:0}}/>

            <Box sx={{display: "flex", alignItems: "center", gap: 1, m: 2, mt: 1}}>
                <AgyleBlockSwitch
                    onChange={(e) => setSwitchValue(e)}
                    value={switchValue}
                    nullState
                    fourCases
                    label="Show only trusted devices"
                    valueObject={{"true": "all", "false": "untrusted", "null": "trusted", "alt": "locked"}}
                    // valueObject={{"true": "all", "false": "untrusted", "null": "trusted"}}
                    customLabels={{
                        yes: t("All"),
                        no: t("Untrusted"),
                        empty: t("Trusted"),
                        alternative: t("Locked"),
                    }}
                />
            </Box>

            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead key={"HEAD"}>
                        {devicesColumns.map((column) => (
                            <TableCell
                                key={column.name}
                                align={column.align}
                                style={{
                                    width: column.width,
                                    border: "1px solid #80808035",
                                }}>
                            <Grid container justifyContent="space-between">
                                <Typography variant="subtitle2" color="textSecondary">
                                    {column.description}
                                </Typography>
                            </Grid>
                            </TableCell>
                        ))}
                    </TableHead>

                    <TableBody>
                        {!_.isEmpty(filteredDevices) && filteredDevices.map((row, index) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                    style={{border: "1px solid #80808035"}}
                                >
                                    {devicesColumns.map((column) => {
                                        const value = row[column.value];

                                        return (
                                            <TableCell key={column.name+value} align={column.align}>
                                                {column.type === ColumnTypes.TEXT && value}
                                                {column.name === 'trusted' && renderDeviceStatus(row)}
                                                {column.type === ColumnTypes.ACTIONS && column.name === 'action' && renderButtons(column, row)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                    </Table>
                {_.isEmpty(filteredDevices) &&
                    <Typography
                        variant="subtitle1"
                        align="center"
                        mt={2}
                        >No devices found.</Typography>
                }
            </TableContainer>

            <MessageBox
                open={isRemoveDeviceDialogOpen}
                onClose={closeConfirmRemoveDevice}
                title={t('Confirmation')}
                message={t(`Do you really want to make device <b>${deviceRef.current?.deviceName}</b> untrusted?`)}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={() => untrustDevice(deviceRef.current)}
                warning
            />

            <MessageBox
                open={isUnlockDeviceDialogOpen}
                onClose={closeConfirmUnlockDevice}
                title={t('Confirmation')}
                message={t('Do you really want to unlock this device?')}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={() => unlockDevice(deviceRef.current)}
                warning
            />

        </Grid>
    )
}

export default TrustedDevices;